import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
   name: 'sdmDate'
})
export class SdmDatePipe implements PipeTransform {

   transform(value: number): Date {
      if (value && value.toString().length === 8) {
         const dateTime = new Date(
            parseInt(value.toString().substr(0, 4), 10),
            parseInt(value.toString().substr(4, 2), 10) - 1,
            parseInt(value.toString().substr(6, 2), 10)
         );

         return dateTime;
      }

      return null;
   }

}
